import { createContext } from 'react';

export type ScenarioHeatmapContextType = {
  heatMapLayers: string[];
};

export const ScenarioHeatmapContext = createContext<ScenarioHeatmapContextType>(
  {
    heatMapLayers: [],
  }
);
